// extracted by mini-css-extract-plugin
module.exports = {"subsidies":"subsidies-KXjAQ","selected":"selected-3Gpo2","price__close":"price__close-1KadE","price":"price-319YQ","selectedFare":"selectedFare-2TVLp"};